/* @flow */
import type { StoreExportFormats } from 'domain/documents/documentsModel';
import ROUTES_PATH from 'domain/router/routesPathConfig';
import { generatePath } from 'react-router-dom';
import { customAlphabet } from 'nanoid';

type exportFormatOption = {|
  value: string,
  label: string,
|};

export const getExportFormatOptions = (formats: StoreExportFormats): Array<exportFormatOption> =>
  Array.from(formats.entries()).map(([value, label]) => ({ value, label }));
export type TPreview = {|
  documentID: string,
  documentItem: Document,
  isLinked: boolean,
|};

export function getDocumentUrl(companyId: string, documentId: string): string {
  return generatePath(ROUTES_PATH.DOCUMENT.absolute, {
    documentId,
    companyId,
  });
}

const alphabet = '0123456789abcdefghijklmnopqrstuvwxyz';
const customNanoid = customAlphabet(alphabet, 10);

export const generateLinkID = () => customNanoid();
